module.exports = __webpack_public_path__ + "assets/img/2e0177e0cd4925d63bdae0147bc4241e.png";